export const validation = {
  documentFor: 'Please select document for',
  countryId: 'Please select country',
  documentName: 'Document name is required',
  dateRequired: 'Please select one of these option',
};
